import { updateAdminOrder, deleteAdminOrder } from '../../../shared/api/orders.services';
import toast from '../../../shared/lib/toast';

// Переход на страницу редактирования
export const putchClick = (orderNumber, navigate) => {
  navigate(`/order-rewrite/${orderNumber}`); // Передаем номер заказа в URL
};

// Полное (физическое) удаление заказа. Безвозвратно — предупреждаем явно.
export const deleteOrderClick = async (orderId, onSuccessRemove) => {
  if (window.confirm('Видалити це замовлення назавжди? Дію не можна скасувати.')) {
    try {
      const response = await deleteAdminOrder(orderId);

      if (!response?.error) {
        toast.success('Замовлення видалено');
        if (onSuccessRemove) onSuccessRemove();
      } else {
        toast.error(response.message || "Помилка при видаленні замовлення.");
      }
    } catch (error) {
      console.error("Помилка при видаленні замовлення:", error);
      toast.error("Не вдалося видалити замовлення. Спробуйте ще раз.");
    }
  }
};

// Если потребуется менять другие статусы прямо из списка
export const changeOrderStatusClick = async (orderId, newStatus, onSuccessRefresh) => {
  try {
    const response = await updateAdminOrder(orderId, { status: newStatus });

    if (!response?.error) {
      toast.success('Статус замовлення оновлено');
      if (onSuccessRefresh) onSuccessRefresh();
    } else {
      toast.error(response.message || "Помилка при зміні статусу");
    }
  } catch (error) {
    console.error("Помилка при зміні статусу замовлення:", error);
    toast.error("Не вдалося змінити статус замовлення. Спробуйте ще раз.");
  }
};